import { Component, OnInit } from '@angular/core';
import { AngularTokenService } from 'angular-token';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray, NgForm } from '@angular/forms';
import { AuthService } from '../auth.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from '../../utils/loader.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  resetPasswordForm: FormGroup;
  sQuery: any;
  headers: HttpHeaders;

  constructor(
    private tokenService: AngularTokenService,
    public authService: AuthService,
    private formBuilder: FormBuilder,
    public router: Router,
    public route: ActivatedRoute,
    private toastr: ToastrService,
    private loaderService: LoaderService,
  ) { }

  ngOnInit() {
    this.resetPasswordForm = new FormGroup({
      'password': new FormControl("", [Validators.required, Validators.minLength(8), Validators.pattern(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/)]),
      'passwordConfirmation': new FormControl("", [Validators.required, Validators.minLength(8), Validators.pattern(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/)]),
    });

    this.route.queryParams.subscribe(params => {
      this.sQuery = params['token'];
      // setting headers
      this.headers = new HttpHeaders({
        "Content-Type": "application/json",
        'uid': params['uid'],
        'client': params['client'],
        'access-token': params['access-token'],
      });
    });
  }

  onSubmit(form) {
    this.loaderService.display(true);
    this.authService.resetPassword(form, { headers: this.headers }).subscribe(
      res => {
        if (this.resetPasswordForm.get('password').value != this.resetPasswordForm.get('passwordConfirmation').value) {
          return this.toastr.error('Your passwords does not match', 'Error')
        }
        else {
          if (this.resetPasswordForm.valid) {
            this.authService.logOut();
            localStorage.clear();
            this.router.navigate(['/login']);
            this.loaderService.display(false);
            this.toastr.success('Successfully updated the password. Please login now.', 'Success');
          }
          else {
            this.toastr.error('Passwords must contain atleast 6 characters', 'Error');
          }
        }
      }, err => {
        this.loaderService.display(false);
        for (let i in err.error.errors) {
          if (err.error.errors[i] == 'must contain at least 6 characters') {
            return this.toastr.error('Password must contain atleast 6 characters', 'Errors');
          }
          this.toastr.error(err.error.errors[i]);
        }
      }
    )
  }

}
